if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

var lastScrollTop = 0;
(function(){

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    $('.easy-scroll').click(function () { 
        var target = $(this).attr("href");
        if($('body.main').length > 0) { var padding = 0; } else { var padding =$('header').height(); }
        $('html, body').animate({scrollTop: $(target).offset().top - padding}, 1000);
        return false;
    });

    $('.sym-slides').slick({
        accessibility: false
    });

    $('.hero__slider').slick({
        arrows: false, 
        autoplay: true, 
        autoplaySpeed: 5000,
        dots: true, 
        fade: true,
        pauseOnHover: false,
        speed: 700
    });

    // FANCYBOXES
    $('.fancybox').fancybox({
        toolbar: false,
        smallBtn: true,
        infobar: false,
        loop: true
    });

    // $('.fancybox-module').fancybox({
    //     baseClass: 'fancybox-popup__wrapper',
    //     arrows: false 
    // });

    window.addEventListener('load', function(){
		var preloader = document.querySelector('.preloader');

		if(preloader) {
			preloader.classList.add('loaded');
		}
	});

    window.onload = function () {
        scrollW();
        window.addEventListener('scroll', function () {
            scrollW();
        })
    }
    function scrollW() {
        let st = window.pageYOffset || document.documentElement.scrollTop;
        if (st > 0) {
            if (st > lastScrollTop) {
                // downscroll code
                if (!document.getElementById('header').classList.contains('down')) {
                    document.getElementById('header').classList.add('down');
                    document.getElementById('header').classList.remove('up');
                }
            } else {
                // upscroll code
                if (!document.getElementById('header').classList.contains('up')) {
                    document.getElementById('header').classList.add('up');
                    document.getElementById('header').classList.remove('down');
                }
            }
        } else {
            if (document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')) {
                document.getElementById('header').classList.remove('up');
                document.getElementById('header').classList.remove('down');
            }
        }
        lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
    }
})();